//export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://services.farmaciasuraba.com/api/v1';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://services.farmaciasuraba.com/api/v1';

export const API_ENDPOINTS = {
  // Autenticación
  auth: {
    login: '/auth/login',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    me: '/auth/me',
    profile: '/auth/profile', // Endpoint que devuelve usuario completo con roles
    changePassword: '/auth/change-password',
  },
  // Usuarios
  users: {
    list: '/users',
    create: '/users',
    update: (id: string) => `/users/${id}`,
    delete: (id: string) => `/users/${id}`,
    toggleStatus: (id: string) => `/users/${id}/toggle-status`,
    resetPassword: (id: string) => `/users/${id}/reset-password`,
    profile: '/users/profile',
    roles: '/users/roles',
  },
  // Membresías
  memberships: {
    create: '/memberships',
  },
  // Clientes
  clientes: {
    list: '/clientes',
    create: '/clientes/registro',
    update: (id: string) => `/clientes/${id}`,
    delete: (id: string) => `/clientes/${id}`,
    detail: (id: string) => `/clientes/${id}`,
    toggleStatus: (id: string) => `/clientes/${id}/toggle-status`,
    stats: '/clientes/stats',
  },
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;
